import gql from 'graphql-tag'

export default gql`mutation login($email: String!, $password: String!){
    login(username:$email, password:$password)
}`
